import { useTranslation } from 'react-i18next';
import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { AuthLayout } from '../components/AuthLayout';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t('notFound.title')} intro={t('notFound.intro')}>
      <Link to="/" className="button button--primary">
        {t('actions.backHome')}
      </Link>
    </AuthLayout>
  );
}

export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  return (
    <AuthLayout title={t('routeError.title')} intro={t('routeError.intro')}>
      <button type="button" className="button button--primary" onClick={() => window.location.reload()}>
        {t('actions.reload')}
      </button>
    </AuthLayout>
  );
}
